import React from 'react';
import styled from 'styled-components';

const Heading = styled.div`
    height: 60vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    @media (max-width: 500px) {
        height: 50vh;
    }
`;

const Title = styled.h1`
    color: ${({ theme: { colors } }) => colors.charcoal};
    font-family: ${({ theme: {fonts} }) => fonts[0]};
    font-size: ${({ theme: { fontSizes } }) => fontSizes.extraLarge};
    text-shadow: ${({ theme: { colors } }) => `1px 1px 25px ${colors.lemon}`};

    @media (max-width: 600px) {
        font-size: ${({ theme: { fontSizes } }) => fontSizes.large};
    }
`;

const Subtitle = styled.h2`
    color: ${({ theme: { colors } }) => colors.lemon};
    font-family: ${({ theme: {fonts} }) => fonts[0]};
    font-size: ${({ theme: { fontSizes } }) => fontSizes.medium};

    @media (max-width: 600px) {
        font-size: ${({ theme: { fontSizes } }) => fontSizes.small};
    }
`;

const Home = () => {
    return (
        <Heading>
            <Title>B Severino</Title>
            <Subtitle>> Front End Developer</Subtitle>  
        </Heading>       
    );
};

export default Home;